import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "work-container" }
const _hoisted_2 = { class: "actions" }

import { computed, ref, onMounted, onBeforeUnmount } from "vue";
import Tabs from "@/components/Tabs.vue";
import useProjectNav from "@/composables/useProjectNav";
import PageHeaderProject from "@/components/PageHeaderProject.vue";
import IconButton from "@/components/IconButton.vue";
import { useIsWorkFullScreen } from "@/composables/useIsWorkFullScreen";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectWork',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;

const projectId = ref("");
const { isWorkFullScreen } = useIsWorkFullScreen();

onMounted(() => {
  projectId.value = props.id;
});
onBeforeUnmount(() => {
  isWorkFullScreen.value = false;
});

const { subTabs } = useProjectNav(projectId);

const fullScreenIconName = computed(() => {
  return isWorkFullScreen.value ? "mdi:fullscreen-exit" : "mdi:fullscreen";
});

const toggleFullScreen = () => {
  isWorkFullScreen.value = !isWorkFullScreen.value;
};

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeaderProject, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
      default: _withCtx(() => [
        (_unref(subTabs) && !_unref(isWorkFullScreen))
          ? (_openBlock(), _createBlock(Tabs, {
              key: 0,
              definitions: _unref(subTabs),
              color: "primary",
              size: "sm"
            }, null, 8, ["definitions"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(IconButton, {
            "icon-name": fullScreenIconName.value,
            onClick: toggleFullScreen
          }, null, 8, ["icon-name"])
        ])
      ]),
      _: 1
    }, 16),
    _createVNode(_component_RouterView, _mergeProps({ class: "current-tab" }, _ctx.$attrs), null, 16)
  ]))
}
}

})